"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetNearestPlaces = createGetNearestPlaces;

var _api = require("../api");

var _query = require("./query");

var _types = require("./types");

var _config = require("../config");

var _utils = require("../utils");

var ALL_PLACE_TYPES = ['bicycleRent', 'bikePark', 'carPark', 'quay', 'stopPlace'];

function convertTypeNameToFilterPlaceType(typeName) {
  switch (typeName) {
    case _types.TypeName.BIKE_PARK:
      return 'bikePark';

    case _types.TypeName.BIKE_RENTAL_STATION:
      return 'bicycleRent';

    case _types.TypeName.CAR_PARK:
      return 'carPark';

    case _types.TypeName.QUAY:
      return 'quay';

    case _types.TypeName.STOP_PLACE:
      return 'stopPlace';

    default:
      return undefined;
  }
}

function createGetNearestPlaces(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getNearestPlaces(coordinates) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var latitude = coordinates.latitude,
        longitude = coordinates.longitude;
    var _params$maximumDistan = params.maximumDistance,
        maximumDistance = _params$maximumDistan === void 0 ? 2000 : _params$maximumDistan,
        _params$maximumResult = params.maximumResults,
        maximumResults = _params$maximumResult === void 0 ? 20 : _params$maximumResult,
        _params$filterByInUse = params.filterByInUse,
        filterByInUse = _params$filterByInUse === void 0 ? false : _params$filterByInUse,
        filterByModes = params.filterByModes,
        _params$filterByPlace = params.filterByPlaceTypes,
        filterByPlaceTypes = _params$filterByPlace === void 0 ? ALL_PLACE_TYPES : _params$filterByPlace,
        _params$multiModalMod = params.multiModalMode,
        multiModalMode = _params$multiModalMod === void 0 ? 'parent' : _params$multiModalMod;
    var variables = {
      latitude: latitude,
      longitude: longitude,
      maximumDistance: maximumDistance,
      maximumResults: maximumResults,
      filterByInUse: filterByInUse,
      filterByModes: filterByModes,
      filterByPlaceTypes: filterByPlaceTypes,
      multiModalMode: multiModalMode
    };

    if (params.filterByPlaceTypes) {
      variables.filterByPlaceTypes = params.filterByPlaceTypes.map(convertTypeNameToFilterPlaceType).filter(_utils.isTruthy);
    }

    return (0, _api.journeyPlannerQuery)(_query.getNearestPlacesQuery, variables, config).then(function (data) {
      var _data$nearest;

      return ((data === null || data === void 0 ? void 0 : (_data$nearest = data.nearest) === null || _data$nearest === void 0 ? void 0 : _data$nearest.edges) || []).map(function (_ref) {
        var node = _ref.node;
        var distance = node.distance,
            place = node.place;
        return {
          distance: distance,
          id: place.id,
          type: place.__typename,
          // eslint-disable-line no-underscore-dangle
          latitude: place.latitude,
          longitude: place.longitude
        };
      });
    });
  };
}